import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: 'select,input'
})
export class DetectAutofillDirective implements AfterViewInit, OnDestroy {
  private unlistenAnimation: () => void;

  constructor(
    private el: ElementRef,
    private ngModel: NgModel,
    private renderer: Renderer2
  ) { }

  ngAfterViewInit() {
    // Listen for the animationstart event to detect browser autofill.
    this.unlistenAnimation = this.renderer.listen(this.el.nativeElement, 'animationstart', (event: AnimationEvent) => {
      if (event && event.animationName === 'autofillStart') {
        // When autofill is detected, update the ngModel with the current value.
        const currentValue = this.el.nativeElement.value;
        this.ngModel.control.setValue(currentValue);
      }
    });
  }

  ngOnDestroy() {
    if (this.unlistenAnimation) {
      this.unlistenAnimation();
    }
  }
}
